/**
 * Calendar: personal appointments + reminders + .ics import/export. Like FTP
 * it is HOST-RENDERED (CalendarView.js) — events are extension_documents
 * records (extension_id 'calendar') in the personal scope, so free/offline
 * fully works and paid plans sync across devices via the existing personal
 * sync engine. The guest entry.js is a no-op kept only to satisfy the
 * registration contract.
 *
 * The icon-rail slot sits right after FTP; clicking it opens the calendar
 * panel (App.js `activeTab === 'calendar.panel'` content branch →
 * CalendarView as a FULL-BLEED page: no sidebar — AppContent's hasSidebar
 * opt-out collapses the column; a MiniMonth sidebar next to a month grid
 * read as a double calendar — owner, fix round 3).
 */
export const calendarManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.calendar',
  name: 'Calendar',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'calendar',
  engines: { apibooSdk: '^1.0.0' },
  // HOST-RENDERED, not sandboxed: `permissions: []` means "declares no GUEST
  // capabilities", not "has no access" — see the ftp manifest / EXT-05.
  hostRendered: true,
  permissions: [],
  contributes: {
    activityBar: [
      {
        id: 'calendar.activity',
        title: 'Calendar',
        icon: 'calendar',
        order: { after: 'ftp.activity' },
      },
    ],
    panels: [{ id: 'calendar.panel', activityBarId: 'calendar.activity', title: 'Calendar' }],
    settings: [],
  },
};
